export const CLIP_REGION_ID = 'clip';
